import { render, staticRenderFns } from "./ActionsIsland.vue?vue&type=template&id=8f404494&scoped=true"
import script from "./ActionsIsland.vue?vue&type=script&lang=ts"
export * from "./ActionsIsland.vue?vue&type=script&lang=ts"
import style0 from "./ActionsIsland.vue?vue&type=style&index=0&id=8f404494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f404494",
  null
  
)

export default component.exports